import moment from 'moment';
import { investmentStatus } from '../../login/utils/Status';
import { Amount, DataRoom, Deal, Issuer } from '../deals/redux/types';
import {
    Audit,
    Booking,
    Derived,
    InvestmentDoc,
    InvestmentFilters,
    Investments,
    Repayment,
    RepaymentInfo,
    Reporting,
    ReportingObligation,
    ReportingObligationDoc,
} from './redux/types';
import { FilterOptions } from './modal/FilterModal';
import { checkIsNumber, instanceOfAmount } from '../../utils/validation';

export const getInterestRate = (currency: string, row: Investments) => {
    let interestRate = '';
    row.interestRates?.map((interest) => {
        if (interest.ccy === currency) {
            interestRate = interest.interestRate;
        }
        return interestRate;
    });
    return interestRate ? `${interestRate}%` : '';
};

export const getInterestRateRepayment = (currency: string, row: Repayment) => {
    let interestRate = '';
    row.deal &&
        row.deal &&
        row.deal.terms &&
        row.deal.terms.interestRates &&
        row.deal.terms.interestRates.map((interest) => {
            if (interest.ccy === currency) {
                interestRate = interest.interestRate;
            }
            return interestRate;
        });
    return `${interestRate}%`;
};

export const getInterestRateInvestment = (interestRates: { ccy: string; interestRate: string }[]) => {
    let interestRate = '';
    interestRates.map((interest) => {
        interestRate = interest.interestRate;
        return interestRate;
    });
    return `${interestRate}%`;
};

export const checkRowOfRowPaid = (repayments: RepaymentInfo[] | undefined) => {
    let count = 0;
    try {
        if (repayments) {
            repayments.forEach((data) => {
                if (data && data.dealRepayment && data.dealRepayment.status === 'PAID') {
                    count++;
                }
            });
            return count;
        }
        return count;
    } catch (err) {
        return count;
    }
};

export const showPayButton = (row: Investments) => {
    if (
        row.status &&
        (row.status === investmentStatus.PendingPaymentReceipt ||
            row.status === investmentStatus.PendingPaymentConfirmation)
    ) {
        return true;
    }

    return false;
};

export const showWithdrawButton = (row: Investments) => {
    if (row.status && row.status === investmentStatus.PendingPaymentReceipt) {
        return true;
    }

    return false;
};

export const showUpdates = (updates: DataRoom[] | undefined) => {
    if (updates && updates.length > 0) {
        return true;
    }
    return false;
};

export const showDropdownMenuOrNot = (i: Investments) => {
    if (showPayButton(i) || showWithdrawButton(i) || i.status === 'Pending_PaymentReceipt') {
        return true;
    }
    return false;
};

const emptyInvestment: Investments = {
    dealName: undefined,
    uuid: '',
    dealType: undefined,
    dealUUID: undefined,
    instrumentType: undefined,
    interestRates: [],
    investmentAmount: undefined,
    investmentDate: undefined,
    issuerName: undefined,
    status: undefined,
    outstandingPrincipal: undefined,
    interestRate: undefined,
    totalDistribution: undefined,
};

export const parseInvestments = (
    data: {
        deal?: Deal;
        issuer: Issuer;
        amount?: Amount;
        audit?: Audit;
        creationAudit?: Audit;
        dealUUID: string;
        investorUUID: string;
        status: string;
        uuid: string;
        bookingUUID?: string;
        documents?: InvestmentDoc[];
        paymentReceipts?: InvestmentDoc[];
        investmentDate?: {
            date?: {
                date: string;
            };
        };
        fundInvestmentInfo?: {
            balanceAmount?: Amount;
            redeemedAmount?: Amount;
            subscriptionDate?: {
                date: string;
            };
        };
        booking?: Booking;
        derived?: Derived;
    }[],
): Investments[] => {
    let res: Investments[] = [];
    data.forEach((item) => {
        const newObj: Investments = { ...emptyInvestment };
        if (item.deal?.info.summary?.title) {
            newObj.dealName = item.deal.info.summary.title;
        }
        if (item.uuid) {
            newObj.uuid = item.uuid;
        }
        if (item.deal?.info.summary?.dealType) {
            newObj.dealType = item.deal.info.summary.dealType;
        }
        if (item.deal?.uuid) {
            newObj.dealUUID = item.deal.uuid;
        }
        if (item.deal?.info.summary?.instrumentType) {
            newObj.instrumentType = item.deal.info.summary.instrumentType;
        }
        if (item.deal?.info.summary?.terms?.interestRates) {
            newObj.interestRates = item.deal.info.summary.terms.interestRates;
        }
        if (item.amount) {
            newObj.investmentAmount = item.amount;
        }
        if (item.issuer?.name) {
            newObj.issuerName = item.issuer?.name;
        }

        newObj.status = item.derived?.status;
        newObj.booking = item.booking;
        newObj.derived = item.derived;
        newObj.totalDistribution = item.derived?.totalDistribution;
        newObj.outstandingPrincipal = item.derived?.outstandingPrincipal;
        newObj.interestRate = item.derived?.interestRate;
        newObj.maturityDate = item.derived?.maturityDate?.date ? item.derived?.maturityDate?.date : undefined;
        newObj.investmentDate = item.investmentDate?.date?.date ? item.investmentDate?.date?.date : undefined;
        res.push(newObj);
    });
    return res;
};

const emptyReportingObligation: ReportingObligation = {
    obligationDate: undefined,
    reports: [],
};

export const parseReportingObligation = (
    data: {
        obligationDate?: {
            date: string;
        };
        reports: Reporting[];
    }[],
): ReportingObligation[] => {
    let res: ReportingObligation[] = [];
    data.forEach((item) => {
        const newObj: ReportingObligation = { ...emptyReportingObligation };
        const index = res.findIndex(
            (r) =>
                r.obligationDate?.date === item.obligationDate?.date &&
                r.reports?.[0].bookingUUID === item.reports?.[0].bookingUUID,
        );
        if (index === -1) {
            newObj.obligationDate = item.obligationDate;
            newObj.reports = item.reports;
            res.push(newObj);
        } else {
            let reportingObligation = { ...res[index] };
            let reports = [...reportingObligation.reports];
            reportingObligation.reports = reports.concat(item.reports);
            res[index] = reportingObligation;
        }
    });
    return res;
};

export const getFilterData = (list: Investments[]) => {
    let filters: InvestmentFilters = {
        dealName: [],
        issuerName: [],
        dealType: [],
        status: [],
        instrumentType: [],
        interestRate: [],
    };
    list.forEach((s) => {
        if (s.dealName) {
            filters.dealName.push(s.dealName);
        }
        if (s.issuerName) {
            filters.issuerName.push(s.issuerName);
        }

        if (s.interestRate) {
            filters.interestRate.push(s.interestRate);
        }

        if (s.dealType) {
            filters.dealType.push(s.dealType);
        }

        if (s.status) {
            filters.status.push(s.status);
        }
        if (s.instrumentType) {
            filters.instrumentType.push(s.instrumentType);
        }
    });

    filters = {
        dealName: Array.from(new Set(filters.dealName)),
        issuerName: Array.from(new Set(filters.issuerName)),
        dealType: Array.from(new Set(filters.dealType)),
        status: Array.from(new Set(filters.status)),
        instrumentType: Array.from(new Set(filters.instrumentType)),
        interestRate: Array.from(new Set(filters.interestRate)),
    };

    return filters;
};

export const getReportColor = (list: ReportingObligationDoc[], date: string) => {
    if (list.length === 0 && moment().isSameOrAfter(date)) {
        return 'color-ef4444';
    }
    if (list.length === 0) {
        return '';
    }
    let r = 0;
    let p = 0;
    list.forEach((l: ReportingObligationDoc) => {
        if (l.status === 'Rejected') {
            r = r + 1;
        }
        if (l.status === 'Pending') {
            p = p + 1;
        }
    });

    if (r > 0) {
        return 'color-ef4444';
    }
    if (p > 0) {
        return 'color-f0ad4e';
    }
    return 'color-53bb47';
};

export const filterRows = (list: any, filterKeys: FilterOptions[]) => {
    return list.filter((product: any) => {
        return filterKeys.every((key) => {
            if (
                (key.value || []).length === 0 &&
                key.minValue === undefined &&
                key.maxValue === undefined &&
                key.toDate === undefined &&
                key.fromDate === undefined
            )
                return true;
            if (Array.isArray(product[key.key])) {
                return product[key.key].some((keyEle: any) => key.value?.includes(keyEle));
            }
            let value: number | undefined = undefined;
            let value1: number | undefined = product[key.key];
            if (value1 !== undefined && new Date(value1)) {
                if (key.fromDate !== undefined && key.toDate !== undefined) {
                    return new Date(value1) >= new Date(key.fromDate) && new Date(key.toDate) >= new Date(value1);
                }
                if (key.fromDate !== undefined) {
                    return new Date(value1) >= new Date(key.fromDate);
                }
                if (key.toDate !== undefined) {
                    return new Date(value1) <= new Date(key.toDate);
                }
            }
            /**Checking key is amount */
            if (instanceOfAmount(product[key.key])) {
                if (product[key.key].amount) {
                    value = product[key.key].amount;
                }
            }
            /**Checking number */
            if (checkIsNumber(String(product[key.key]))) {
                if (
                    product[key.key] &&
                    (typeof product[key.key] === 'string' || typeof product[key.key] === 'number')
                ) {
                    value = parseFloat(String(product[key.key]).replaceAll(',', ''));
                }
            }
            if (value !== undefined) {
                if (key.minValue !== undefined && key.maxValue !== undefined) {
                    return value >= key.minValue && key.maxValue >= value;
                }
                if (key.minValue !== undefined) {
                    return value >= key.minValue;
                }
                if (key.maxValue !== undefined) {
                    return value <= key.maxValue;
                }
            }

            return key.value?.includes(product[key.key]);
        });
    });
};
